module.exports = require("@seddi/three/examples/jsm/postprocessing/RenderPass.js");